// Header.js


import './styles.css';
import { Link, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import imagem from './images/logotipo.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

const Sidebar = ({ sidebar }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setCurrentUser(JSON.parse(storedUser));
    }

    // Verifica se esta no modo mobile
    toggleSidebarClass();
    window.addEventListener("resize", toggleSidebarClass);

    // Limpeza do listener
    return () => {
      window.removeEventListener("resize", toggleSidebarClass);
    };
  }, []);

  function toggleSidebarClass() {
    let screenWidth = window.innerWidth;

    let sidebar = document.getElementById("sidebar");
    let divNoWrap = document.getElementById("divNoWrap");

    let isSmallScreen = screenWidth < 992;

    sidebar.classList.remove("show");

    sidebar.classList.toggle("show", !isSmallScreen);
    sidebar.classList.toggle("sidebar", !isSmallScreen);
    sidebar.classList.toggle("position-fixed", !isSmallScreen);

    sidebar.classList.toggle("fixed-top", isSmallScreen);
    sidebar.classList.toggle("collapsedContentMargin", isSmallScreen);

    if (divNoWrap)
      divNoWrap.classList.toggle("flex-nowrap", !isSmallScreen);
  }

    window.addEventListener("resize", toggleSidebarClass);

  return (
    <div className="sidebar position-fixed collapse show p-3 shadow" id="sidebar" style={{backgroundColor: "#fff"}}>
      <ul className="nav nav-pills flex-column mb-auto">
        <li>
          <Link className={`nav-link sidebarLink mb-1 link ${location.pathname === "/controlpanel" ? "sidebarSelected" : ""}`} to="/controlpanel" reloadDocument>
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-bar-chart" viewBox="0 0 20 20">
            <path d="M4 11H2v3h2zm5-4H7v7h2zm5-5v12h-2V2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z"/>
          </svg>
            <span className='fs-5 ms-3 d-lg-none d-xxl-inline'>Painel</span>
          </Link>
        </li>
        <li>
          <Link className={`nav-link sidebarLink mb-1 link ${location.pathname === "/filelist" ? "sidebarSelected" : ""}`} to="/filelist" reloadDocument>
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-file-earmark-text" viewBox="0 0 20 20">
            <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"/>
            <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>
          </svg>
            <span className='fs-5 ms-3 d-lg-none d-xxl-inline'>Arquivos Processados</span>
          </Link>
        </li>
        <li>
          <Link className={`nav-link sidebarLink mb-1 link ${location.pathname === "/askdata" ? "sidebarSelected" : ""}`} to="/askdata" reloadDocument>
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-chat-square-text" viewBox="0 0 20 20">
            <path d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
            <path d="M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6m0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"/>
          </svg>
            <span className='fs-5 ms-3 d-lg-none d-xxl-inline'>Perguntar Dados</span>
          </Link>
        </li>

        <li>
          <p className="d-inline-flex gap-1">
            <a className="nav-link sidebarLink" data-bs-toggle="collapse" href="#collapseDropDown" role="button" aria-expanded="false" aria-controls="collapseExample">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-plus-circle-dotted" viewBox="0 0 20 20">
                <path d="M8 0q-.264 0-.523.017l.064.998a7 7 0 0 1 .918 0l.064-.998A8 8 0 0 0 8 0M6.44.152q-.52.104-1.012.27l.321.948q.43-.147.884-.237L6.44.153zm4.132.271a8 8 0 0 0-1.011-.27l-.194.98q.453.09.884.237zm1.873.925a8 8 0 0 0-.906-.524l-.443.896q.413.205.793.459zM4.46.824q-.471.233-.905.524l.556.83a7 7 0 0 1 .793-.458zM2.725 1.985q-.394.346-.74.74l.752.66q.303-.345.648-.648zm11.29.74a8 8 0 0 0-.74-.74l-.66.752q.346.303.648.648zm1.161 1.735a8 8 0 0 0-.524-.905l-.83.556q.254.38.458.793l.896-.443zM1.348 3.555q-.292.433-.524.906l.896.443q.205-.413.459-.793zM.423 5.428a8 8 0 0 0-.27 1.011l.98.194q.09-.453.237-.884zM15.848 6.44a8 8 0 0 0-.27-1.012l-.948.321q.147.43.237.884zM.017 7.477a8 8 0 0 0 0 1.046l.998-.064a7 7 0 0 1 0-.918zM16 8a8 8 0 0 0-.017-.523l-.998.064a7 7 0 0 1 0 .918l.998.064A8 8 0 0 0 16 8M.152 9.56q.104.52.27 1.012l.948-.321a7 7 0 0 1-.237-.884l-.98.194zm15.425 1.012q.168-.493.27-1.011l-.98-.194q-.09.453-.237.884zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a7 7 0 0 1-.458-.793zm13.828.905q.292-.434.524-.906l-.896-.443q-.205.413-.459.793zm-12.667.83q.346.394.74.74l.66-.752a7 7 0 0 1-.648-.648zm11.29.74q.394-.346.74-.74l-.752-.66q-.302.346-.648.648zm-1.735 1.161q.471-.233.905-.524l-.556-.83a7 7 0 0 1-.793.458zm-7.985-.524q.434.292.906.524l.443-.896a7 7 0 0 1-.793-.459zm1.873.925q.493.168 1.011.27l.194-.98a7 7 0 0 1-.884-.237zm4.132.271a8 8 0 0 0 1.012-.27l-.321-.948a7 7 0 0 1-.884.237l.194.98zm-2.083.135a8 8 0 0 0 1.046 0l-.064-.998a7 7 0 0 1-.918 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
              </svg>
              <span className='fs-5 ms-3 d-lg-none d-xxl-inline'>Novo Processamento</span>
            </a>
          </p>
          <div className={`collapse ${location.pathname === "/fileupload" || location.pathname ===  "/batchfileupload" ? "show" : ""}`} id="collapseDropDown">
            <div>
              <Link className={`nav-link sidebarLink link ${location.pathname === "/fileupload" ? "sidebarSelected show" : ""}`} to="/fileupload" reloadDocument>
              &nbsp;&nbsp;&nbsp;&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-file-earmark" viewBox="0 0 20 20">
                <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z"/>
              </svg>
                <span className='fs-6 ms-3 d-lg-none d-xxl-inline'>Individual</span>
              </Link>
            </div>
            <div>
              <Link className={`nav-link sidebarLink link ${location.pathname === "/batchfileupload" ? "sidebarSelected show" : ""}`} to="/batchfileupload" reloadDocument>
              &nbsp;&nbsp;&nbsp;&nbsp;<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-archive" viewBox="0 0 20 20">
                <path d="M0 2a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1v7.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V5a1 1 0 0 1-1-1zm2 3v7.5A1.5 1.5 0 0 0 3.5 14h9a1.5 1.5 0 0 0 1.5-1.5V5zm13-3H1v2h14zM5 7.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5"/>
              </svg>
              <span className='fs-6 ms-3 d-lg-none d-xxl-inline'>Lote</span>
              </Link>
            </div>
          </div>
        </li>
        {currentUser && currentUser.isAdmin && (
        <li>
          <Link className="nav-link sidebarLink" to={{ pathname: "/configuration" }} reloadDocument >
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-boxes" viewBox="0 0 16 16">
            <path d="M7.752.066a.5.5 0 0 1 .496 0l3.75 2.143a.5.5 0 0 1 .252.434v3.995l3.498 2A.5.5 0 0 1 16 9.07v4.286a.5.5 0 0 1-.252.434l-3.75 2.143a.5.5 0 0 1-.496 0l-3.502-2-3.502 2.001a.5.5 0 0 1-.496 0l-3.75-2.143A.5.5 0 0 1 0 13.357V9.071a.5.5 0 0 1 .252-.434L3.75 6.638V2.643a.5.5 0 0 1 .252-.434zM4.25 7.504 1.508 9.071l2.742 1.567 2.742-1.567zM7.5 9.933l-2.75 1.571v3.134l2.75-1.571zm1 3.134 2.75 1.571v-3.134L8.5 9.933zm.508-3.996 2.742 1.567 2.742-1.567-2.742-1.567zm2.242-2.433V3.504L8.5 5.076V8.21zM7.5 8.21V5.076L4.75 3.504v3.134zM5.258 2.643 8 4.21l2.742-1.567L8 1.076zM15 9.933l-2.75 1.571v3.134L15 13.067zM3.75 14.638v-3.134L1 9.933v3.134z"/>
          </svg>
            <span className='fs-5 ms-3 d-lg-none d-xxl-inline'>Configuration</span>
          </Link>
        </li>
        
        )}
        {currentUser && currentUser.isAdmin && (
        <li>
          <Link className="nav-link sidebarLink" to={{ pathname: "/usagedata" }} reloadDocument >
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-clipboard-data-fill" viewBox="0 0 16 16">
            <path d="M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"/>
            <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5zM10 8a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zm4-3a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1"/>
          </svg>
            <span className='fs-5 ms-3 d-lg-none d-xxl-inline'>Usage Data</span>
          </Link>
        </li>
        
        )}
      </ul>

      <hr className="d-lg-none d-lg-inline"/>
      
      <div className="dropdown d-lg-none d-lg-inline">
        <a href="#" className="d-flex align-items-center text-decoration-none dropdown-toggle nav-link fs-5 ms-3" data-bs-toggle="dropdown" aria-expanded="false">
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
          <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
          <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1"/>
        </svg>
          <strong className="fs-5 ms-3 d-lg-none d-xxl-inline">{currentUser && currentUser.Login}</strong>
        </a>
        <ul className="dropdown-menu dropdown-menu-white text-small shadow">
          {/* <li><a className="dropdown-item" href="#">...</a></li> */}
          {/* <li><hr className="dropdown-divider"/></li> */}
          <li><Link className="dropdown-item" to={{ pathname: "/" }} reloadDocument >Sair</Link></li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
